import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_project_hdr_RowClass,
  bl_alg_cc_project_hdr_RowInterface
} from "../../../../dbschema/bl_alg_cc_project_hdr.model";
import {bl_alg_cc_project_line_RowClass} from "../../../../dbschema/bl_alg_cc_project_line.model";
import {bl_alg_cc_project_ext_RowClass} from "../../../../dbschema/bl_alg_cc_project_ext.model";
import {bl_alg_cc_project_event_RowClass} from "../../../../dbschema/bl_alg_cc_project_event.model";

export class ProjectContainerModel extends BaseContainerModel {
  bl_alg_cc_project_hdr: bl_alg_cc_project_hdr_RowInterface = new bl_alg_cc_project_hdr_RowClass();
  bl_alg_cc_project_lines: bl_alg_cc_project_line_RowClass[] = [];
  bl_alg_cc_project_exts: bl_alg_cc_project_ext_RowClass[] = [];
  bl_alg_cc_project_events: bl_alg_cc_project_event_RowClass[] = [];
}
